import React from 'react';
import styled from 'styled-components';
import { css } from 'styled-components';
import { Link } from 'react-router-dom';

const currentYear = new Date().getFullYear();

const FooterWrap = styled.footer`
  background: rgba(255, 255, 255, 0.78);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  color: rgba(55, 53, 53, 0.88);
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.95rem;
  margin: 2rem auto 0;
  max-width: 680px;
  padding: 1rem 1.25rem;
  position: relative;
  text-align: center;
  z-index: 0;

  ${({ floating }) =>
    floating &&
    css`
      margin-top: 0;

      @media (min-width: 768px) {
        bottom: -0.9rem;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        width: calc(100% - 6rem);
      }
    `}
`;

const Company = styled.div`
  font-weight: 600;
  line-height: 1.5;
`;

const TaxId = styled.div`
  color: rgba(55, 53, 53, 0.72);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-top: 0.15rem;
`;

const LegalLinks = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.75rem;
  justify-content: center;
  margin-top: 0.85rem;
`;

const LegalLink = styled(Link)`
  color: #a10204;
  font-size: 0.9rem;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Footer = ({ floating = false }) => (
  <FooterWrap floating={floating}>
    <Company>&copy; {currentYear} BAMBAN SUSHI es un producto de Crosswall Investments SRL</Company>
    <TaxId>RNC 131-02499-8</TaxId>
    <LegalLinks>
      <LegalLink to="/legal/security">Seguridad</LegalLink>
      <LegalLink to="/legal/refunds">Reembolsos</LegalLink>
      <LegalLink to="/legal/delivery">Entrega</LegalLink>
      <LegalLink to="/legal/terms">Términos</LegalLink>
      <LegalLink to="/legal/privacy">Privacidad</LegalLink>
      <LegalLink to="/legal/cookies">Cookies</LegalLink>
    </LegalLinks>
  </FooterWrap>
);

export default Footer;
